import InteractiveSpline from '@modules/three/common/curve/interactiveSpline/InteractiveSpline';
import SplineControlPoint from './SplineControlPoint';

export interface EventHandler {
  onPointerDown(selectedPoint: SplineControlPoint): void;
  onPointerMove(event: PointerEvent): void;
  onPointerUp(event: PointerEvent): void;
  dispose(): void;
}

export default abstract class BasePointerHandler implements EventHandler {
  protected interactiveSpline: InteractiveSpline;

  private boundOnPointerMove = this.onPointerMove.bind(this);
  private boundOnPointerUp = this.handlePointerUp.bind(this);

  constructor(interactiveSpline: InteractiveSpline) {
    this.interactiveSpline = interactiveSpline;
    this.addListeners();
  }

  protected addListeners(): void {
    document.addEventListener('pointermove', this.boundOnPointerMove);
    document.addEventListener('pointerup', this.boundOnPointerUp);
  }

  dispose(): void {
    document.removeEventListener('pointermove', this.boundOnPointerMove);
    document.removeEventListener('pointerup', this.boundOnPointerUp);
  }

  private handlePointerUp(event: PointerEvent): void {
    this.onPointerUp(event);
  }

  abstract onPointerDown(selectedPoint: SplineControlPoint): void;
  abstract onPointerMove(event: PointerEvent): void;
  abstract onPointerUp(event: PointerEvent): void;
}
